module.exports = __webpack_public_path__ + "img/avatar.64a211b3.png";